<template>
  <div class="carGameManagement-container">
    <el-row class="queryForm">
      <el-form inline :model="queryForm" ref="queryForm">
        <el-form-item class="r-20" prop="name">
          <el-input
            v-model.trim="queryForm.name"
            placeholder="维保店名称"
            @keyup.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="type">
          <el-select v-model="queryForm.type" placeholder="--类型--" clearable>
            <el-option
              v-for="item in typeList"
              :label="item.label"
              :value="item.value"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="r-20" prop="cityIds">
          <el-cascader
            v-model="queryForm.cityIds"
            size="mini"
            placeholder="请选择省市区"
            ref="cascader"
            :options="areaCityList"
            :props="{
              emitPath: true,
              multiple: true,
              checkStrictly: false,
              value: 'id',
              children: 'areaDTOList',
              label: 'name',
            }"
            clearable
            collapse-tags
          >
          </el-cascader>
          <!-- <el-select
            v-model="queryForm.city"
            placeholder="--省市区县--"
            clearable
          >
            <el-option
              v-for="item in cityList"
              :label="item.name"
              :value="item.type"
              :key="item.type"
            ></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item class="r-20" prop="state">
          <el-select v-model="queryForm.state" placeholder="--状态--" clearable>
            <el-option
              v-for="item in stateList"
              :label="item.label"
              :value="item.value"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button @click="reset">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-button type="primary" @click="addMaintenance">新增</el-button>
    </el-row>
    <el-row class="table-top">
      <el-table :data="tableData" height="560px">
        <el-table-column width="10"></el-table-column>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column
          label="绑定账号"
          min-width="100"
          prop="bindAccount"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="维保店名称"
          min-width="100"
          prop="storeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="类型" min-width="80" prop="storeType">
          <template slot-scope="{ row }">
            <span v-if="row.storeType == 1">4s店</span>
            <span v-else-if="row.storeType == 2">二级维修店</span>
            <span v-else-if="row.storeType == 3">三级维修店</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="联系人"
          min-width="120"
          prop="linkman"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          min-width="120"
          prop="linkPhone"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="客服电话"
          min-width="120"
          prop="servicePhone"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属省"
          min-width="80"
          prop="province"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属市"
          min-width="80"
          prop="city"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属区县"
          min-width="100"
          prop="area"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="详细地址"
          min-width="120"
          prop="address"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <div class="address">
              <div class="address-text">{{ row.address }}</div>
              <i class="iconfont icon-weizhi1" @click="openMap(row)"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="80" prop="storeState">
          <template slot-scope="{ row }">
            <span v-if="row.storeState == 1">开启</span>
            <span v-else-if="row.storeState == 2">关闭</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="180" fixed="right">
          <template slot-scope="{ row }">
            <div class="options">
              <el-button
                type="text"
                @click="closeStatus(row, 2)"
                v-if="row.storeState == 1"
                >关闭</el-button
              >
              <el-button
                type="text"
                @click="closeStatus(row, 1)"
                v-else-if="row.storeState == 2"
                >开启</el-button
              >
              <el-button type="text" @click="editor(row)">编辑</el-button>
              <el-button type="text" @click="deleteData(row.id)"
                >删除</el-button
              >
              <el-button type="text" @click="checkDetails(row.id, 2)"
                >详情</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 新增、修改维保店弹框 -->
    <el-dialog
      :title="titleText"
      :visible.sync="outerVisible"
      class="dialogForm"
      @close="clearData"
      v-if="outerVisible"
    >
      <el-dialog class="inner-map" :visible.sync="innerVisible" append-to-body>
        <div id="innerMap"></div>
        <div class="myPageTop">
          <el-input
            placeholder="请输入关键字检索内容"
            v-model="poi"
            id="tipInput"
            @input="searchPoi"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchPoi"
            ></el-button>
          </el-input>
          <div id="poiInfo"></div>
        </div>

        <div class="infoWindow" ref="lookInfoWindow" v-show="showInfoWindow">
          {{ infoWindowData.address }}
        </div>
        <el-button type="primary" class="saveLocation" @click="saveLocation"
          >保存</el-button
        >
      </el-dialog>
      <div class="dialogForm-form">
        <el-form
          :model="dialogForm"
          inline
          label-width="160px"
          label-position="left"
          ref="dialogFormData"
          :rules="dialogFormRules"
        >
          <el-row>
            <el-col :span="12" class="short">
              <el-form-item label="维保店服务等级" prop="storeType">
                <el-select
                  v-model="dialogForm.storeType"
                  placeholder="请选择维保店服务等级"
                  clearable
                >
                  <el-option
                    v-for="item in maintenanceTypeList"
                    :label="item.label"
                    :value="item.value"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="origin">
              <el-form-item
                label="绑定账号"
                prop="bindAccountId"
                label-width="100px"
              >
                <el-select
                  v-model="dialogForm.bindAccountId"
                  placeholder="请输入绑定账号"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in bindAccountList"
                    @click.native="getAccountList(item.userId)"
                    :label="item.username"
                    :value="item.userId"
                    :key="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="long">
            <el-form-item label="维保店名称" prop="storeName">
              <el-input
                placeholder="请输入维保店名称"
                v-model.trim="dialogForm.storeName"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12" class="short">
              <el-form-item label="联系人" prop="linkman">
                <el-input
                  v-model.trim="dialogForm.linkman"
                  autocomplete="off"
                  placeholder="请输入联系人"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="origin">
              <el-form-item
                label="联系电话"
                prop="linkPhone"
                label-width="100px"
                ref="linkPhoneRef"
              >
                <el-input
                  v-model.trim="dialogForm.linkPhone"
                  autocomplete="off"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-form-item label="经纬度" class="require">
              <el-col :span="8">
                <el-form-item prop="longitude">
                  <el-input
                    placeholder="经度"
                    v-model.trim="dialogForm.longitude"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="latitude">
                  <el-input
                    placeholder="纬度"
                    v-model.trim="dialogForm.latitude"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <i class="iconfont icon-weizhi1"></i>
                <span style="paddingLeft:4px"></span>
                <el-button type="text" @click="toChooseLocation"
                  >地图定位</el-button
                >
              </el-col>
            </el-form-item>
          </el-row> -->
          <el-row class="long">
            <el-form-item label="详细地址" class="require">
              <el-row class="address-style">
                <el-col :span="6">
                  <el-form-item prop="provinceId">
                    <el-select
                      v-model="dialogForm.provinceId"
                      placeholder="省"
                      class="select-item"
                      @visible-change="handleProvinceChange"
                      disabled
                    >
                      <el-option
                        v-for="item in provinceList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="cityId">
                    <el-select
                      v-model="dialogForm.cityId"
                      placeholder="市"
                      class="select-item"
                      @visible-change="handleCityChange"
                      disabled
                    >
                      <el-option
                        v-for="item in cityList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="areaId">
                    <el-select
                      v-model="dialogForm.areaId"
                      placeholder="区/县"
                      class="select-item"
                      @visible-change="handleAreaChange"
                      disabled
                    >
                      <el-option
                        v-for="item in areaList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <i class="iconfont icon-weizhi1"></i>
                  <span style="paddingLeft:4px"></span>
                  <el-button type="text" @click="toChooseLocation"
                    >地图定位</el-button
                  >
                </el-col>
                <!-- <el-input
                  placeholder="省市区县、乡镇等通过定位获取"
                  disabled
                  v-model.trim="str1"
                ></el-input> -->
              </el-row>
              <el-row class="long">
                <el-form-item prop="address">
                  <el-input
                    placeholder="请输入街道、楼牌等详细地址"
                    v-model.trim="dialogForm.address"
                    clearable
                    disabled
                  ></el-input>
                </el-form-item>
              </el-row>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12" class="short">
              <el-form-item label="工作日">
                <el-col :span="11">
                  <el-form-item prop="workdayStart">
                    <el-select
                      v-model="dialogForm.workdayStart"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in dayStartList"
                        :label="item.label"
                        :value="item.id"
                        :key="item.id"
                        :disabled="item.disabled"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="1" class="line">-</el-col>
                <el-col :span="11" class="short">
                  <el-form-item prop="workdayEnd">
                    <el-select
                      v-model="dialogForm.workdayEnd"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in dayEndList"
                        :label="item.label"
                        :value="item.id"
                        :key="item.id"
                        :disabled="item.disabled"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="short">
              <el-form-item label="是否24小时值班" prop="isAllDay">
                <el-radio-group v-model="dialogForm.isAllDay">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="short">
              <el-form-item label="工作时间" class="work">
                <el-col :span="11">
                  <el-form-item prop="workTimeStart">
                    <el-time-picker
                      v-model="dialogForm.workTimeStart"
                      placeholder="08:00"
                      format="HH:mm"
                      value-format="HH:mm"
                      :picker-options="{
                        selectableRange: `00:00:00 -${
                          dialogForm.workTimeEnd
                            ? dialogForm.workTimeEnd + ':60'
                            : '23:59:00'
                        }`,
                      }"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="1" class="line">-</el-col>
                <el-col :span="11">
                  <el-form-item prop="workTimeEnd">
                    <el-time-picker
                      v-model="dialogForm.workTimeEnd"
                      placeholder="18:00"
                      format="HH:mm"
                      value-format="HH:mm"
                      :picker-options="{
                        selectableRange: `${
                          dialogForm.workTimeStart
                            ? dialogForm.workTimeStart + ':60'
                            : '00:00:00'
                        }-23:59:00`,
                      }"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="short"></el-col>
          </el-row>
          <el-row class="long">
            <el-form-item label="周末节假日是否上班" prop="isRestDayWork">
              <el-radio-group v-model="dialogForm.isRestDayWork">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="客服电话" prop="servicePhone">
                <el-input
                  placeholder="请输入客服电话"
                  v-model.trim="dialogForm.servicePhone"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="origin">
              <el-form-item
                label="工位数"
                prop="stationCount"
                label-width="100px"
              >
                <el-input
                  placeholder="请输入工位数"
                  v-model.trim="dialogForm.stationCount"
                ></el-input>
                <!-- <el-select
                  v-model="dialogForm.stationCount"
                  placeholder="请选择工位数"
                  clearable
                >
                  <el-option
                    v-for="item in stationNumList"
                    :label="item.number"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="editorFlag" style="height:32px;margin-bottom:20px">
            <el-col style="width:160px">编辑附件</el-col>
            <el-col :span="12">
              <el-button type="primary" @click="editImgChange"
                >编辑附件</el-button
              >
            </el-col>
          </div>
          <div v-if="editorFlag">
            <div style="height:100px;margin-bottom:30px">
              <el-col :span="4">资质证书</el-col>
              <el-col :span="20">
                <el-image
                  v-for="item in credentialsData"
                  :key="item.index"
                  style="width:148px;height:100px;margin-right:20px;margin-bottom:20px;"
                  :src="item.realurl"
                  :preview-src-list="credentialsDataSrcList"
                >
                </el-image>
              </el-col>
            </div>
            <div style="height:100px;margin-bottom:20px">
              <el-col :span="4">维保店图片</el-col>
              <el-col :span="20">
                <el-image
                  v-for="item in storePhotosData"
                  :key="item.index"
                  style="width:148px;height:100px;margin-right:20px;margin-bottom:20px"
                  :src="item.realurl"
                  :preview-src-list="storePhotosDataSrcList"
                >
                </el-image>
              </el-col>
            </div>
          </div>
        </el-form>
        <el-form
          v-if="!editorFlag"
          :model="dialogForm"
          label-position="top"
          ref="addPhotosForm"
        >
          <el-row>
            <el-form-item
              label="编辑资质证书（最大支持5张照片上传，单个照片最大支持2MB）"
              prop="addCredentials"
              label-width="100px"
            >
              <el-upload
                ref="addImg1Upload"
                action="#"
                list-type="picture-card"
                :auto-upload="false"
                :on-preview="addCredentialsPreview"
                :on-change="addCredentialsChange"
                :on-remove="addCredentialsRemove"
                class="avatar-uploader"
                :file-list="addCredentialsList"
                accept=".jpg,.jpeg,.png"
                :limit="5"
              >
                <i class="el-icon-plus photos-uploader-icon"></i>
              </el-upload>
              <el-dialog
                :visible.sync="addImg1Flag"
                append-to-body
                class="upload-img"
              >
                <img width="100%" :src="addImg1" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item
              label="编辑店面图片（第一张请上传店面正门图片，最大支持16张照片上传，单个照片最大支持2MB）"
              prop="addStorePhotos"
              label-width="100px"
            >
              <el-upload
                ref="addImg2Upload"
                action="#"
                list-type="picture-card"
                :auto-upload="false"
                :on-preview="addStorePhotosPreview"
                :on-change="addStorePhotosChange"
                :on-remove="addStorePhotosRemove"
                class="avatar-uploader"
                :file-list="addStorePhotosList"
                accept=".jpg,.jpeg,.png"
                :limit="16"
              >
                <i class="el-icon-plus photos-uploader-icon"></i>
              </el-upload>
              <el-dialog
                :visible.sync="addImg2Flag"
                append-to-body
                class="upload-img"
              >
                <img width="100%" :src="addImg2" alt="" />
              </el-dialog>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button @click="clearData">取 消</el-button>
        <el-button type="primary" @click="saveConfirm">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 编辑上传图片 -->
    <el-dialog
      v-if="editorFlag"
      class="img-dialog"
      title=""
      :visible.sync="imgVisible"
      @close="imgCancel"
    >
      <el-form
        :model="dialogForm"
        label-position="top"
        ref="photosForm"
        class="twoForm"
      >
        <el-row>
          <el-form-item
            label="编辑资质证书（最大支持5张照片上传，单个照片最大支持2MB）"
            prop="credentials"
            label-width="100px"
          >
            <el-upload
              ref="img1Upload"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :on-preview="credentialsPreview"
              :on-change="credentialsChange"
              :on-remove="credentialsRemove"
              class="avatar-uploader"
              :file-list="credentialsList"
              accept=".jpg,.jpeg,.png"
              :limit="5"
            >
              <i class="el-icon-plus photos-uploader-icon"></i>
            </el-upload>
            <el-dialog
              :visible.sync="img1Flag"
              append-to-body
              class="upload-img"
            >
              <img width="100%" :src="img1" alt="" />
            </el-dialog>
          </el-form-item>
          <el-form-item
            label="编辑店面图片（第一张请上传店面正门图片，最大支持16张照片上传，单个照片最大支持2MB）"
            prop="storePhotos"
            label-width="100px"
          >
            <el-upload
              ref="img2Upload"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :on-preview="storePhotosPreview"
              :on-change="storePhotosChange"
              :on-remove="storePhotosRemove"
              class="avatar-uploader"
              :file-list="storePhotosList"
              accept=".jpg,.jpeg,.png"
              :limit="16"
            >
              <i class="el-icon-plus photos-uploader-icon"></i>
            </el-upload>
            <el-dialog
              :visible.sync="img2Flag"
              append-to-body
              class="upload-img"
            >
              <img width="100%" :src="img2" alt="" />
            </el-dialog>
          </el-form-item>
        </el-row>
      </el-form>
      <div style="text-align:right">
        <el-button @click="imgCancel">取消</el-button>
        <el-button type="primary" @click="saveImg">保存</el-button>
      </div>
    </el-dialog>

    <!-- 地图定位弹框 -->
    <el-dialog class="map-dialog" title="" :visible.sync="dialogVisibleMap">
      <div id="positionMap"></div>
    </el-dialog>

    <!-- 查看维保店详情 -->
    <el-dialog
      class="details-dialog"
      title="查看维保店详情"
      :visible.sync="dialogDetails"
    >
      <el-row class="row-line">
        <el-col :span="12">
          <el-col :span="8" class="label">维保店类型</el-col>
          <el-col :span="16" v-if="detailsData.storeType == 1">4s店</el-col>
          <el-col :span="16" v-else-if="detailsData.storeType == 2"
            >二级维修店</el-col
          >
          <el-col :span="12" v-else-if="detailsData.storeType == 3"
            >三级维修店</el-col
          >
          <el-col :span="12" v-else>-</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="6" class="label">绑定用户名</el-col>
          <el-col :span="18">{{ $judgeEmpty(detailsData.bindAccount) }}</el-col>
        </el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="4" class="label">店名</el-col>
        <el-col :span="20">{{ $judgeEmpty(detailsData.storeName) }}</el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="12">
          <el-col :span="8" class="label">联系人</el-col>
          <el-col :span="16">{{ $judgeEmpty(detailsData.linkman) }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="6" class="label">联系电话</el-col>
          <el-col :span="12">{{ $judgeEmpty(detailsData.linkPhone) }}</el-col>
        </el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="12">
          <el-col :span="8" class="label">经度</el-col>
          <el-col :span="16">{{ $judgeEmpty(detailsData.longitude) }}</el-col>
        </el-col>
        <el-col :span="7">
          <el-col :span="6" class="label">纬度</el-col>
          <el-col :span="18">{{ $judgeEmpty(detailsData.latitude) }}</el-col>
        </el-col>
        <el-col :span="5">
          <el-col :span="6" class="label">定位</el-col>
          <el-col :span="18"
            ><i class="iconfont icon-weizhi1" @click="openMap(detailsData)"></i
          ></el-col>
        </el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="4" class="label">详细地址</el-col>
        <el-col :span="20">{{ $judgeEmpty(detailsAddress) }}</el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="12">
          <el-col :span="8" class="label">工作时间</el-col>
          <el-col :span="16">
            <span>{{ $judgeEmpty(detailsData.workTimeStart) }}</span>
            <span> ~ </span>
            <span>{{ $judgeEmpty(detailsData.workTimeEnd) }}</span>
          </el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="8" class="label">是否24小时值班</el-col>
          <el-col :span="16" v-if="detailsData.isAllDay == 1">是</el-col>
          <el-col :span="16" v-else-if="detailsData.isAllDay === 0">否</el-col>
          <el-col :span="16" v-else>-</el-col>
        </el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="4" class="label">工作日</el-col>
        <el-col :span="20"
          >{{ changeWorkday(detailsData.workdayStart) }} ~
          {{ changeWorkday(detailsData.workdayEnd) }}</el-col
        >
      </el-row>
      <el-row class="row-line">
        <el-col :span="4" class="label">节假日是否上班</el-col>
        <el-col :span="20" v-if="detailsData.isRestDayWork == 1">是</el-col>
        <el-col :span="20" v-else-if="detailsData.isRestDayWork === 0"
          >否</el-col
        >
        <el-col :span="18" v-else>-</el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="4" class="label">客服电话</el-col>
        <el-col :span="20">{{ $judgeEmpty(detailsData.servicePhone) }}</el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="4" class="label">工位数</el-col>
        <el-col :span="20">{{ $judgeEmpty(detailsData.stationCount) }}</el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="4" class="label">资质证书图片</el-col>
        <el-col :span="20">
          <el-image
            v-for="(item, index) in detailsData.certificateRealUrl"
            :key="index + item"
            style="width: 200px; height: 120px;margin-right:20px"
            :src="item"
            fit="contain"
            :preview-src-list="[item]"
          ></el-image>
        </el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="4" class="label">店面图片</el-col>
        <el-col :span="20">
          <el-image
            v-for="(item, index) in detailsData.storePhotoRealUrl"
            :key="index + item"
            style="width: 200px; height: 120px;margin-right:20px"
            :src="item"
            fit="contain"
            :preview-src-list="[item]"
          ></el-image>
        </el-col>
      </el-row>
    </el-dialog>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>


<!--预加载 SimpleMarker -->
<script src="//webapi.amap.com/ui/1.1/ui/overlay/SimpleMarker.js"></script>
<script>
import AMap from "AMap";
export default {
  name: "CarGameManagement",
  data() {
    // const checkCertificates = (rule, value, callback) => {
    //   if (this.credentialsFileList.length > 0) {
    //     callback();
    //   } else {
    //     callback(new Error("请上传资质证书！"));
    //   }
    // };
    // const checkStorePhotos = (rule, value, callback) => {
    //   if (this.storePhotosFileList.length > 0) {
    //     callback();
    //   } else {
    //     callback(new Error("请上传店面照片！"));
    //   }
    // };
    // const addCheckStorePhotos = (rule, value, callback) => {
    //   if (this.addStorePhotosFileList.length > 0) {
    //     callback();
    //   } else {
    //     callback(new Error("请上传店面照片！"));
    //   }
    // };
    // const addCheckCertificates = (rule, value, callback) => {
    //   if (this.addCredentialsFileList.length > 0) {
    //     callback();
    //   } else {
    //     callback(new Error("请上传资质证书！"));
    //   }
    // };
    return {
      poi: "",
      poiList: "",
      storeId: null,
      queryForm: {
        name: "",
        type: "",
        cityIds: [],
        state: "",
      },
      detailsAddress: "",
      outerVisible: false,
      innerVisible: false,
      dialogVisibleMap: false,
      dialogDetails: false,
      typeList: [
        { id: 1, label: "4s店", value: 1 },
        { id: 2, label: "二级维修店", value: 2 },
        { id: 3, label: "三级维修店", value: 3 },
      ],
      areaCityList: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      stateList: [
        { id: 1, label: "开启", value: 1 },
        { id: 2, label: "关闭", value: 2 },
      ],
      tableData: [],
      currentPage: 1,
      limit: 10,
      total: 0,
      dialogForm: {
        storeType: "",
        bindAccount: "",
        storeName: "",
        linkman: "",
        linkPhone: "",
        longitude: "",
        latitude: "",
        provinceId: null,
        cityId: null,
        areaId: null,
        province: "",
        city: "",
        area: "",
        address: "",
        workdayStart: "",
        workdayEnd: "",
        isRestDayWork: "",
        isAllDay: "",
        workTimeStart: "",
        workTimeEnd: "",
        stationCount: "",
        servicePhone: "",
      },
      str1: "",
      str2: "",
      titleText: "",
      imgVisible: false,
      dialogFormRules: {
        storeType: [
          { required: true, trigger: "change", message: "请选择维保店类型" },
        ],
        bindAccount: [
          { required: true, trigger: "blur", message: "请输入绑定账号" },
        ],
        storeName: [
          { required: true, trigger: "change", message: "请输入维保店名称" },
        ],
        linkPhone: [
          {
            pattern: this.$formRules.phone,
            required: true,
            trigger: "change",
            message: this.$formRules.phoneMsg,
          },
        ],
        linkman: [{ required: true, trigger: "blur", message: "请输入联系人" }],
        longitude: [
          { required: true, trigger: "change", message: "请输入经度" },
        ],
        latitude: [{ required: true, trigger: "blur", message: "请输入纬度" }],

        provinceId: [{ required: true, trigger: "blur", message: "请选择" }],
        cityId: [{ required: true, trigger: "blur", message: "请选择" }],
        areaId: [{ required: true, trigger: "blur", message: "请选择" }],
        address: [
          { required: true, trigger: "blur", message: "请输入详细地址" },
        ],
        workdayStart: [{ required: false, trigger: "blur", message: "请选择" }],
        workdayEnd: [{ required: false, trigger: "blur", message: "请选择" }],
        dayStart: [
          {
            required: false,
            trigger: "blur",
            message: "请选择",
          },
        ],
        dayEnd: [
          {
            required: false,
            trigger: "blur",
            message: "请选择",
          },
        ],
        isAllDay: [
          {
            required: false,
            trigger: "blur",
            message: "请选择是否24小时值班",
          },
        ],
        workTimeStart: [{ required: false, trigger: "blur", message: "请选择" }],
        workTimeEnd: [{ required: false, trigger: "blur", message: "请选择" }],
        isRestDayWork: [
          {
            required: false,
            trigger: "blur",
            message: "请选择周末节假日是否上班",
          },
        ],
        stationCount: [
          {
            required: false,
            trigger: "blur",
            message: "请选择工位数",
          },
        ],
      },
      // photosRules: {
      //   storePhotos: [
      //     {
      //       required: true,
      //       validator: checkStorePhotos,
      //       trigger: "change",
      //     },
      //   ],
      //   credentials: [
      //     { required: true, trigger: "change", validator: checkCertificates },
      //   ],
      // },
      // addPhotosRules: {
      //   addStorePhotos: [
      //     {
      //       required: true,
      //       validator: addCheckStorePhotos,
      //       trigger: "change",
      //     },
      //   ],
      //   addCredentials: [
      //     {
      //       required: true,
      //       trigger: "change",
      //       validator: addCheckCertificates,
      //     },
      //   ],
      // },
      maintenanceTypeList: [
        { id: 1, label: "4s店", value: 1 },
        { id: 2, label: "二级维修店", value: 2 },
        { id: 3, label: "三级维修店", value: 3 },
      ],
      dayStartList: [
        { id: 1, label: "周一", disabled: false },
        { id: 2, label: "周二", disabled: false },
        { id: 3, label: "周三", disabled: false },
        { id: 4, label: "周四", disabled: false },
        { id: 5, label: "周五", disabled: false },
        { id: 6, label: "周六", disabled: false },
        { id: 7, label: "周日", disabled: false },
      ],
      dayEndList: [
        { id: 1, label: "周一", disabled: false },
        { id: 2, label: "周二", disabled: false },
        { id: 3, label: "周三", disabled: false },
        { id: 4, label: "周四", disabled: false },
        { id: 5, label: "周五", disabled: false },
        { id: 6, label: "周六", disabled: false },
        { id: 7, label: "周日", disabled: false },
      ],
      avatarFileList: [],
      photosFileList: [],
      map: null,
      innerMap: null,
      marker: null,
      infoWindow: null,
      addMarker: null,
      clickMarker: null,
      showInfoWindow: false,
      infoWindowData: {
        address: "",
      },
      geocoder: null,
      editorFlag: false,
      detailsData: {},
      bindAccountList: [],
      img1Flag: false,
      img2Flag: false,
      img1: "",
      img2: "",
      addImg1Flag: false,
      addImg2Flag: false,
      addImg1: "",
      addImg2: "",
      credentialsFileList: [],
      storePhotosFileList: [],
      credentialsData: [],
      storePhotosData: [],
      credentialsList: [],
      storePhotosList: [],
      credentialsDataSrcList: [],
      storePhotosDataSrcList: [],
      addCredentialsFileList: [],
      addStorePhotosFileList: [],
      addCredentialsList: [],
      addStorePhotosList: [],
    };
  },
  watch: {
    "dialogForm.workdayStart": {
      handler: function(val) {
        this.dayEndList.forEach((day) => {
          if (val && day.id < val) {
            day.disabled = true;
          } else {
            day.disabled = false;
          }
        });
      },
      deep: true,
      immediate: true,
    },
    "dialogForm.workdayEnd": {
      handler: function(val) {
        this.dayStartList.forEach((day) => {
          if (val && day.id > val) {
            day.disabled = true;
          } else {
            day.disabled = false;
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getAreaList();
    this.getTableList();
    this.getAccountList();
  },
  methods: {
    searchPoi() {
      //SimpleMarker已经加载，这里loadUI可以立即回调
      AMapUI.loadUI(["misc/PoiPicker"], (PoiPicker) => {
        let poiPicker = new PoiPicker({
          input: "tipInput",
        });
        //初始化poiPicker
        this.poiPickerReady(poiPicker);
      });
    },
    poiPickerReady(poiPicker) {
      window.poiPicker = poiPicker;
      let marker = new AMap.Marker();
      //选取了某个POI
      poiPicker.on("poiPicked", (poiResult) => {
        let poi = poiResult.item;
        marker.setMap(this.innerMap);
        marker.setPosition(poi.location);
        this.innerMap.setCenter(marker.getPosition());
      });
      // poiPicker.onCityReady(function() {
      //   poiPicker.suggest(keyword);
      // });
    },
    changeWorkday(start) {
      if (start == 1) {
        return "周一";
      } else if (start == 2) {
        return "周二";
      } else if (start == 3) {
        return "周三";
      } else if (start == 4) {
        return "周四";
      } else if (start == 5) {
        return "周五";
      } else if (start == 6) {
        return "周六";
      } else if (start == 7) {
        return "周日";
      } else {
        return "-";
      }
    },
    imgCancel() {
      this.imgVisible = false;
      // 清空编辑附件的校验信息
      this.$refs.photosForm.clearValidate();
    },
    // 提交图片文件数据
    saveImg() {
      let obj1 = this.handleUploadImg(this.credentialsFileList, 1);
      let obj2 = this.handleUploadImg(this.storePhotosFileList, 2);
      this.$refs.photosForm.validate((photos) => {
        if (photos) {
          this.patchImg(obj1);
          this.patchImg(obj2);
        }
      });
    },
    handleUploadImg(fileList, type) {
      let imgIds = [];
      let imgs = [];
      fileList.forEach((item) => {
        if (item.status == "success") {
          imgIds.push(item.index);
        } else {
          imgs.push(item.raw);
        }
      });
      let obj = new FormData();
      obj.append("id", this.storeId);
      obj.append("imgIds", imgIds);
      obj.append("type", type);
      imgs.forEach((item) => {
        obj.append("imgs", item);
      });
      return obj;
    },
    async patchImg(obj) {
      let { data: res } = await this.$axios.patch(
        "/api/maintenance/updateImgs",
        obj
      );
      if (res.code == 1) {
        this.$message.warning("操作成功！");
        // 关闭编辑图片弹框
        this.imgVisible = false;
        // // 刷新编辑数据
        // this.checkDetails(this.storeId, 1);
        // 刷新编辑文件数据
        this.getImgData(this.storeId, 1);
        this.getImgData(this.storeId, 2);
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 编辑附件
    editImgChange() {
      // 清空文件数据
      if (this.$refs.img1Upload) {
        this.$refs.img1Upload.clearFiles();
      }
      if (this.$refs.img2Upload) {
        this.$refs.img2Upload.clearFiles();
      }
      setTimeout(() => {
        // 打开编辑图片弹框
        this.imgVisible = true;
      }, 1000);
      // 处理显示文件列表数据
      this.credentialsList = [...this.handleFileShow(this.credentialsData, 1)];
      this.storePhotosList = [...this.handleFileShow(this.storePhotosData, 2)];
      this.credentialsFileList = [...this.credentialsList];
      this.storePhotosFileList = [...this.storePhotosList];
    },
    // 处理显示文件列表数据
    handleFileShow(fileList, type) {
      let imgList = [];
      let name = "";
      fileList.map((item) => {
        name = item.realurl.substring(item.realurl.lastIndexOf("/") + 1);
        imgList.push({
          name: name,
          url: item.realurl,
          index: item.index,
          type: type,
        });
      });
      return imgList;
    },
    credentialsPreview(file) {
      this.img1 = file.url;
      this.img1Flag = true;
    },
    credentialsChange(file, fileList) {
      this.credentialsFileList.push(file);
      // 筛选掉格式不正常的文件
      this.uploadImage(file, fileList, this.credentialsFileList);
    },
    credentialsRemove(file) {
      this.deleteFile(file, this.credentialsFileList);
    },
    storePhotosPreview(file) {
      this.img2 = file.url;
      this.img2Flag = true;
    },
    storePhotosChange(file, fileList) {
      this.storePhotosFileList.push(file);
      // 筛选掉格式不正常的文件
      this.uploadImage(file, fileList, this.storePhotosFileList);
    },
    storePhotosRemove(file) {
      this.deleteFile(file, this.storePhotosFileList);
    },
    addCredentialsPreview(file) {
      this.addImg1 = file.url;
      this.addImg1Flag = true;
    },
    addCredentialsChange(file, fileList) {
      this.addCredentialsFileList.push(file);
      // 筛选掉格式不正常的文件
      this.uploadImage(file, fileList, this.addCredentialsFileList);
    },
    addCredentialsRemove(file) {
      this.deleteFile(file, this.addCredentialsFileList);
    },
    addStorePhotosPreview(file) {
      this.addImg2 = file.url;
      this.addImg2Flag = true;
    },
    addStorePhotosChange(file, fileList) {
      this.addStorePhotosFileList.push(file);
      // 筛选掉格式不正常的文件
      this.uploadImage(file, fileList, this.addStorePhotosFileList);
    },
    addStorePhotosRemove(file) {
      this.deleteFile(file, this.addStorePhotosFileList);
    },
    async getImgData(id, type) {
      let obj = {};
      obj.id = id;
      obj.type = type;
      let { data: res } = await this.$axios.get("/api/maintenance/selectImgs", {
        params: obj,
      });
      if (res.code == 1) {
        if (type == 1) {
          this.credentialsData = res.data;
          this.handleShowSrcList(res.data, type);
        } else if (type == 2) {
          this.storePhotosData = res.data;
          this.handleShowSrcList(res.data, type);
        } else {
          this.$message.warning(res.msg);
        }
      } else {
        this.$message.warning(res.msg);
      }
    },
    handleShowSrcList(data, type) {
      let length = data.length;
      let list = [];
      if (length > 0) {
        for (let i = 0; i < length; i++) {
          list.push(data[i].realurl);
        }
      }
      if (type == 1) {
        this.credentialsDataSrcList = list;
      } else if (type == 2) {
        this.storePhotosDataSrcList = list;
      }
    },
    // 保存添加的标记点
    saveLocation() {
      if (!this.clickMarker && !this.marker) {
        // 未添加位置标记点
        this.$message.warning("未添加位置标记点!");
      } else {
        // 将位置坐标信息转换为地址信息
        let pName = "";
        let cName = "";
        let aName = "";
        let address = "";
        let pcd = "";
        let add = "";
        let addMarker = null;
        if (this.clickMarker) {
          addMarker = this.clickMarker;
        } else {
          addMarker = this.marker;
        }
        this.geocoder.getAddress(addMarker.De.position, (status, result) => {
          if (status === "complete" && result.info === "OK") {
            // result为对应的地理位置详细信息
            // this.dialogForm.address = result.regeocode.formattedAddress;
            pcd = result.regeocode.addressComponent;
            add = result.regeocode.formattedAddress;
            pName = pcd.province;
            cName = pcd.city || pcd.province;
            aName = pcd.district;
            address = this.separateAddress(add);
            // 获取省市区id，赋值
            this.getProvinceId(pName, cName, aName).then(() => {
              // 保存成功之后刷新省市区列表数据
              this.getProvince(1, 1);
              this.getProvince(this.dialogForm.provinceId, 2);
              this.getProvince(this.dialogForm.cityId, 3);
            });
            // 右键选中的位置address信息赋值给form表单
            this.dialogForm.address = address;
            this.dialogForm.province = pName;
            this.dialogForm.city = cName;
            this.dialogForm.area = aName;
          }
        });
        this.dialogForm.longitude = addMarker.De.position.lng;
        this.dialogForm.latitude = addMarker.De.position.lat;
        // 保存成功，关闭内弹框
        setTimeout(() => {
          this.innerVisible = false;
        }, 800);
      }
    },
    async getProvinceId(pName, cName, aName) {
      let obj = {};
      obj.pName = pName;
      obj.cName = cName;
      obj.aName = aName;
      let { data: res } = await this.$axios.get("/api/cn/places/selectByName", {
        params: obj,
      });
      if (res.code == 1) {
        this.dialogForm.provinceId = res.data.provinceId;
        this.dialogForm.cityId = res.data.cityId;
        this.dialogForm.areaId = res.data.areaId;
      } else {
        this.$message.warning(res.msg);
      }
    },
    openMap(row) {
      this.dialogVisibleMap = true;
      this.editorFlag = false;
      this.checkDetails(row.id, 1).then(() => {
        this.$nextTick(() => {
          this.initMap();
          if (this.dialogForm.longitude && this.dialogForm.latitude) {
            let location = [
              this.dialogForm.longitude,
              this.dialogForm.latitude,
            ];
            this.addMarkers(location);
            this.map.add(this.marker);
            this.map.setFitView();
            this.map.setZoom(12);
          }
        });
      });
    },
    // 处理省市区数据
    separateAddress(address) {
      let reg =
        "((?<province>[^省]+^自治区|.*?自治区|.*?省|.*?行政区|.*?市)|上海|北京|天津|重庆)(?<city>上海城区|北京城区|天津城区|重庆城区|重庆郊县|[^市]+自治州|.*?自治县|.*?地区|.*?行政单位|.+盟|市辖区|香港岛|九龙半岛|新界|澳门半岛|海南州|屯昌县|临高县|定安县|澄迈县|神农架林区|路环岛|非堂区|氹仔|离岛|.*?市)(?<county>[^县]+县|.*?区|.*?市|.*?旗|.*?镇|.*?路氹城)?(?<town>[^乡镇]+乡镇|.*?街道|.*?社区|.*?办事处乡|.*?办事处|.*?管理处|.*?管委会|.*?苏木|.*?中心|.*?场|.*?区|.+镇|.+乡|.*?团|.*?业局|.*?工园|.*?业园|.*?管理局|.*?群岛|.*?委员会|.*?中心|.*?指挥部|.*?公司|.*?办公室|.*?江镜华侨|.*?梅西水库|.*?曹妃甸新城|.*?察北|.*?工业基地|.*?桐湖|.*?中法武汉生态示范城|.*?钢都花园|.*?太平川|.*?东宝新村|.*?科教新城|.*?滨江新城|.*?农业高新园|.*?建筑材料厂|.*?农科所|.*?阿荣旗林业和草原局|.*?门源监狱|.*?福海监狱|.*?新疆农业科学院玛纳斯县试验站)?(?<village>.*)";
      // 处理省市区，乡镇，街道分开
      // let str1 = address.lastIndexOf("市");
      // 省、市、区、乡镇
      // let province =
      //   address.match(reg).groups.province == undefined
      //     ? ""
      //     : address.match(reg).groups.province;
      // let city =
      //   address.match(reg).groups.city == undefined
      //     ? ""
      //     : address.match(reg).groups.city;
      // let county =
      //   address.match(reg).groups.county == undefined
      //     ? ""
      //     : address.match(reg).groups.county;
      let town =
        address.match(reg).groups.town == undefined
          ? ""
          : address.match(reg).groups.town;
      let village =
        address.match(reg).groups.village == undefined
          ? ""
          : address.match(reg).groups.village;
      // let str1 = province + city + county;
      let str2 = town + village;
      return str2;
    },
    async getAreaList() {
      let { data: res } = await this.$axios.get(
        "/api/cn/places/selectAllPlaces"
      );
      if (res.code == 1) {
        this.areaCityList = res.data;
        // 处理省市区数据
        this.handleAddress(res.data);
      } else {
        this.$message.warning(res.msg);
      }
    },
    // el-cascader 控件 最后一级出现空白 暂无数据 页面
    handleAddress(data) {
      data.forEach((item) => {
        if (item.areaDTOList.length == 0) {
          item.areaDTOList = undefined;
        } else {
          this.handleAddress(item.areaDTOList);
        }
      });
      return data;
    },
    async getProvince(pid, type) {
      if (pid && type) {
        let obj = {};
        obj.pid = pid;
        obj.type = type;
        let { data: res } = await this.$axios.get(
          "/api/cn/places/selectPlaces",
          {
            params: obj,
          }
        );
        if (res.code == 1) {
          if (type == 1) {
            this.provinceList = res.data;
          } else if (type == 2) {
            this.cityList = res.data;
          } else if (type == 3) {
            this.areaList = res.data;
          }
        } else {
          this.$message.warning(res.msg);
        }
      }
    },
    // 获取省
    handleProvinceChange(val) {
      if (val) {
        if (this.dialogForm.cityId || this.dialogForm.areaId) {
          this.dialogForm.cityId = "";
          this.dialogForm.areaId = "";
        }
      }
    },
    // 打开市，获取市数据
    handleCityChange(val) {
      if (val) {
        if (this.dialogForm.areaId) {
          this.dialogForm.areaId = "";
        }
        this.getProvince(this.dialogForm.provinceId, 2);
      }
    },
    // 打开区
    handleAreaChange(val) {
      if (val) {
        this.getProvince(this.dialogForm.cityId, 3);
      }
    },
    // 添加地图标记点
    addMarkers(location) {
      if (this.marker) {
        // 清空数据【创建新的数据时】
        this.map.remove(this.marker);
        this.innerMap.remove(this.marker);
        this.marker = null;
      }
      if (location && location.length != 0) {
        this.marker = new AMap.Marker({
          position: location,
        });
        // 将位置坐标信息转换为地址信息
        this.geocoder.getAddress(location, (status, result) => {
          if (status === "complete" && result.info === "OK") {
            // result为对应的地理位置详细信息
            let address = result.regeocode.formattedAddress;
            this.marker.setLabel({
              offset: new AMap.Pixel(20, 20),
              content: address,
            });
          }
        });
      } else {
        this.$message.warning("未查询到数据!");
      }
      // else if (row.address) {
      //   // 将地址信息转换为位置坐标信息
      //   this.geocoder.getLocation(row.address, (status, result) => {
      //     if (status === "complete" && result.geocodes.length > 0) {
      //       let location = result.geocodes[0].location;
      //       if (this.editorFlag) {
      //         // 编辑打开
      //         // result为对应的地理位置详细信息
      //         this.dialogForm.longitude = result.geocodes[0].location.lng;
      //         this.dialogForm.latitude = result.geocodes[0].location.lat;
      //         // 将位置坐标信息转换为地址信息
      //         this.geocoder.getAddress(location, (status, result) => {
      //           if (status === "complete" && result.info === "OK") {
      //             // result为对应的地理位置详细信息
      //             let address = result.regeocode.formattedAddress;
      //             // let { str1, str2 } = this.separateAddress(address);
      //             // this.str1 = str1;
      //             // this.str2 = str2;
      //           } else {
      //             this.$message.warning("获取地址信息失败！");
      //           }
      //         });
      //       } else {
      //         this.marker = new AMap.Marker({
      //           position: location,
      //         });
      //         this.map.add(this.marker);
      //         this.map.setFitView(this.marker);
      //         this.marker.setLabel({
      //           direction: "right",
      //           offset: new AMap.Pixel(10, 0), //设置文本标注偏移量
      //           content: `<div class='info'>${row.address}</div>`, //设置文本标注内容
      //         });
      //       }
      //     } else {
      //       this.$message.warning("获取经纬度信息失败! ");
      //     }
      //   });
      // }
    },
    initMap() {
      this.map = new AMap.Map("positionMap", {
        resizeEnable: true,
        zoom: 16,
        zooms: [3, 20],
        expandZoomRange: true,
      });
      this.innerMap = new AMap.Map("innerMap", {
        resizeEnable: true,
        zoom: 16,
        zooms: [3, 20],
        expandZoomRange: true,
        // defaultCursor:'cursor'
      });
      // 创建 infoWindow 实例
      this.infoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: this.$refs.lookInfoWindow, //传入 dom 对象，或者 html 字符串
        offset: new AMap.Pixel(16, -40),
      });

      AMap.plugin("AMap.Geocoder", () => {
        this.geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "全国",
        });
      });
    },
    // 删除图片文件
    deleteFile(file, fileList) {
      for (let i in fileList) {
        // 上传的这个file匹配到上传列表中的img，这一项不满足要求需要删除
        if (file == fileList[i]) {
          fileList.splice(i, 1);
        }
      }
    },
    // 添加/修改确定提交
    saveConfirm() {
      let _this = this;
      _this.$refs.dialogFormData.validate(async (valid) => {
        if (valid) {
          if (this.editorFlag) {
            // 编辑提交
            let obj = {};
            Object.assign(obj, { ...this.dialogForm });
            // if (
            //   this.credentialsData.length > 0 &&
            //   this.storePhotosData.length > 0
            // ) {
              let { data: res } = await this.$axios.patch(
                "/api/maintenance/update",
                obj
              );
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.outerVisible = false;
                // 刷新分页数据
                this.getTableList();
              } else {
                this.$message.warning(res.msg);
              }
            // }
          } else {
            _this.$refs.addPhotosForm.validate(async (valid) => {
              if (valid) {
                // 新增提交
                let addObj = new FormData();
                addObj.append("entity", JSON.stringify(this.dialogForm));
                this.addCredentialsFileList.forEach((item) => {
                  addObj.append("certificates", item.raw);
                });
                this.addStorePhotosFileList.forEach((item) => {
                  addObj.append("storePhotos", item.raw);
                });
                let { data: res } = await this.$axios.post(
                  "/api/maintenance/insert",
                  addObj
                );
                if (res.code == 1) {
                  this.$message.success(res.msg);
                  this.outerVisible = false;
                  this.getTableList();
                } else {
                  this.$message.warning(res.msg);
                }
              }
            });
          }
        }
      });
    },

    // 地图选择经纬度
    toChooseLocation() {
      // 开启弹框
      this.innerVisible = true;
      this.poi = "";
      this.$nextTick(() => {
        this.initMap();
        this.searchPoi();
        if (this.clickMarker) {
          // 清空数据【创建新的数据时】
          this.clickMarker.setMap(null);
          this.clickMarker = null;
        }
        if (this.dialogForm.longitude && this.dialogForm.latitude) {
          let location = [this.dialogForm.longitude, this.dialogForm.latitude];
          this.addMarkers(location);
          this.innerMap.add(this.marker);
          this.innerMap.setFitView();
          this.innerMap.setZoom(12);
        }
        this.innerMap.setDefaultCursor("pointer");
        //创建右键菜单
        let contextMenu = new AMap.ContextMenu();
        let contextMenuPosition = null;

        //地图绑定鼠标右击事件——弹出右键菜单
        this.innerMap.on("rightclick", (e) => {
          contextMenu.open(this.innerMap, e.lnglat);
          contextMenuPosition = e.lnglat;
          // 将位置坐标信息转换为地址信息
          this.geocoder.getAddress(contextMenuPosition, (status, result) => {
            if (status === "complete" && result.info === "OK") {
              // result为对应的地理位置详细信息
              this.infoWindowData.address = result.regeocode.formattedAddress;
            }
          });
          // 显示信息窗口
          this.showInfoWindow = true;
          this.infoWindow.open(this.innerMap, contextMenuPosition);
        });
        //右键添加Marker标记
        contextMenu.addItem(
          "添加标记",
          () => {
            if (this.clickMarker) {
              // 添加新的标记点时，删除前一个创建的标记点
              this.clickMarker.setMap(null);
              this.clickMarker = null;
            }
            this.clickMarker = new AMap.Marker({
              map: this.innerMap,
              position: contextMenuPosition, //基点位置
            });
          },
          3
        );
        this.innerMap.on("click", () => {
          // 关闭地址信息窗体
          this.showInfoWindow = false;
          if (this.infoWindow) {
            this.infoWindow.close();
          }
        });
      });
    },
    query() {
      this.getTableList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getTableList();
    },
    // 新增维保店
    addMaintenance() {
      this.editorFlag = false;
      // 清除表单数据
      Object.keys(this.dialogForm).map((item) => {
        this.dialogForm[item] = "";
      });
      this.dialogForm.certificateUrl = null;
      this.dialogForm.storePhotoUrl = null;
      this.dialogForm.certificateRealUrl = null;
      this.dialogForm.storePhotoRealUrl = null;
      this.credentialsDataSrcList = [];
      this.storePhotosDataSrcList = [];
      // 清除工作日数据
      this.dayStartList.forEach((item) => {
        item.disabled = false;
      });
      this.dayEndList.forEach((item) => {
        item.disabled = false;
      });
      // 清除省市区数据
      this.provinceList = [];
      this.cityList = [];
      this.areaList = [];
      // 清除图片文件
      if (this.$refs.addImg1Upload) {
        this.$refs.addImg1Upload.clearFiles();
      }
      if (this.$refs.addImg2Upload) {
        this.$refs.addImg2Upload.clearFiles();
      }
      // 关闭地址信息窗体
      this.showInfoWindow = false;
      if (this.infoWindow) {
        this.infoWindow.close();
      }
      // 清除信息窗体数据
      this.infoWindowData.address = "";
      this.addCredentialsFileList = [];
      this.addStorePhotosFileList = [];
      this.titleText = "新增维保店";
      this.outerVisible = true;
    },
    // 将改维保店设置为关闭状态
    async closeStatus(row, state) {
      let { data: res } = await this.$axios.patch(
        "/api/maintenance/switch?id=" + row.id + "&state=" + state
      );
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.getTableList();
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 编辑维保店信息
    editor(row) {
      this.editorFlag = true;
      // 清除表单数据
      Object.keys(this.dialogForm).map((item) => {
        this.dialogForm[item] = "";
      });
      this.dialogForm.certificateUrl = null;
      this.dialogForm.storePhotoUrl = null;
      this.dialogForm.certificateRealUrl = null;
      this.dialogForm.storePhotoRealUrl = null;
      this.credentialsDataSrcList = [];
      this.storePhotosDataSrcList = [];
      this.provinceList = [];
      this.cityList = [];
      this.areaList = [];
      // 清除工作日数据
      this.dayStartList.forEach((item) => {
        item.disabled = false;
      });
      this.dayEndList.forEach((item) => {
        item.disabled = false;
      });
      // 关闭地址信息窗体
      this.showInfoWindow = false;
      if (this.infoWindow) {
        this.infoWindow.close();
      }
      // 清除信息窗体数据
      this.infoWindowData.address = "";
      // 赋值数据
      this.checkDetails(row.id, 1);
      this.storeId = row.id;
      // 获取文件图片数据
      this.getImgData(row.id, 1);
      this.getImgData(row.id, 2);
      this.titleText = "编辑维保店";
      setTimeout(() => {
        this.outerVisible = true;
      }, 800);
    },
    clearData() {
      // 清除数据
      Object.keys(this.dialogForm).map((item) => {
        this.dialogForm[item] = "";
      });
      this.dialogForm.certificateUrl = null;
      this.dialogForm.storePhotoUrl = null;
      this.dialogForm.certificateRealUrl = null;
      this.dialogForm.storePhotoRealUrl = null;
      this.credentialsDataSrcList = [];
      this.storePhotosDataSrcList = [];
      this.outerVisible = false;
    },
    // 删除该维保店数据
    deleteData(id) {
      let ids = [id];
      // $confirm(message, title, options) 或 $confirm(message, options)
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let { data: res } = await this.$axios.delete(
          "/api/maintenance/delete",
          {
            data: JSON.stringify(ids),
          }
        );
        if (res.code == 1) {
          this.$message.success("操作成功");
          // 向上取整，当前页码数
          let totalPage = Math.ceil((this.total - 1) / 10);
          let currentPage =
            this.currentPage > totalPage ? totalPage : this.currentPage;
          this.currentPage = currentPage < 1 ? 1 : currentPage;
          // 重新获取表数据[刷新]
          this.getTableList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 查看维保店详情数据
    async checkDetails(id, value) {
      this.detailsAddress = "";
      let { data: res } = await this.$axios.get("/api/maintenance/selectOne", {
        params: { id: id },
      });
      if (res.code == 1) {
        if (value == 1) {
          // 编辑
          this.dialogForm = res.data;
        } else if (value == 2) {
          // 详情
          this.dialogDetails = true;
          this.detailsData = res.data;
          let province = res.data.province;
          let city = res.data.city;
          let area = res.data.area;
          this.detailsAddress = province + city + area + res.data.address;
        }
        this.getAddressId();
      } else {
        this.$message.warning(res.msg);
      }
    },
    getAddressId() {
      // 得到地址信息
      this.getProvince(1, 1);
      if (this.dialogForm.provinceId) {
        this.getProvince(this.dialogForm.provinceId, 2);
      }
      if (this.dialogForm.cityId) {
        this.getProvince(this.dialogForm.cityId, 3);
      }
    },
    // 判断上传的是否为图片和限制图片格式
    uploadImage(file, fileList, uploadList) {
      const img = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt1M = file.size / 1024 / 1024 < 2;
      if (img != "jpg" && img != "png" && img != "jpeg") {
        this.$message.error("请上传正确的图片格式!");
        this.deleteFile(file, fileList);
        this.deleteFile(file, uploadList);
        return false;
      }
      // 可以限制图片的大小
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过2MB!");
        this.deleteFile(file, fileList);
        this.deleteFile(file, uploadList);
      }
    },
    // 获取表格数据
    async getAccountList(userId) {
      let { data: res } = await this.$axios.get(
        "/api/maintenance/selectStoreAccounts"
      );
      if (res.code == 1) {
        this.bindAccountList = res.data;
        if (userId) {
          res.data.forEach((item) => {
            if (item.userId == userId) {
              this.dialogForm.storeName = item.fullName;
            }
          });
        }
      }
    },

    // 获取表格数据
    async getTableList() {
      let obj = {};
      obj.storeName = this.queryForm.name;
      obj.storeType = this.queryForm.type;
      obj.storeState = this.queryForm.state;
      obj.areaIds = this.queryForm.cityIds.join(", ");
      obj.page = this.currentPage;
      obj.limit = this.limit;
      let { data: res } = await this.$axios.get("/api/maintenance/listAll", {
        params: obj,
      });
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss" scoped>
.carGameManagement-container {
  height: calc(100% - 60px);
  margin: 20px;
  padding: 20px 20px 0 20px;
  background: #fff;

  .img-dialog {
    ::v-deep .el-dialog__body {
      overflow-y: auto;
      padding: 30px !important;
    }
  }

  .upload-dialog {
    /deep/ .el-dialog__body {
      padding: 30px 0 0 0;
    }
  }

  ::v-deep .el-cascader__tags {
    width: 58%;
    flex-wrap: nowrap;
  }
  /deep/ .amap-marker-label {
    width: 200px;
    white-space: normal;
    line-height: 18px;
  }
  .map-dialog {
    #positionMap {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
    ::v-deep .el-dialog {
      width: 1200px;
      height: 60vh;
    }
    /deep/ .el-dialog__body {
      padding: 30px 0 0 0;
      height: calc(100% - 30px);
    }
  }
  .details-dialog {
    /deep/ .el-dialog {
      min-width: 700px;
      .el-dialog__body {
        height: 700px;
        overflow: scroll;
      }
    }
    .row-line {
      margin-bottom: 26px !important;
      .label {
        font-weight: 600;
      }
      .iconfont {
        color: #0094ff;
      }
    }
  }
  .table-top {
    margin-top: 20px !important;
  }
  .address {
    display: flex;
    align-items: center;
    color: #0094ff;
    .address-text {
      width: 72px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    // /deep/ .el-button {
    //   display: block;
    //   width: 60%;
    //   text-align: right;
    // }
    .el-icon-location-outline {
      display: block;
      width: 10%;
      font-size: 18px;
    }
  }
  .options {
    padding-left: 5px;
  }
  .queryForm {
    /deep/ .el-input {
      width: 200px;
    }
  }
  .dialogForm,
  .queryForm {
    /deep/ .el-form .el-input__inner {
      width: 100%;
      padding-left: 15px;
    }
    /deep/ .el-date-editor {
      width: 100%;
      .el-input__prefix {
        right: 5px;
        left: auto;
      }
    }
    .origin {
      /deep/ .el-form-item {
        width: 100%;
        .el-form-item__content {
          width: 260px;
        }
      }
    }
    .short {
      /deep/ .el-form-item {
        width: 100%;
        .el-form-item__content {
          width: calc(100% - 230px);
          .el-input__inner {
            width: 100%;
          }
          .el-form-item__content {
            width: 100%;
          }
        }
      }
    }
    .long {
      /deep/ .el-form-item {
        width: 100%;
        .el-form-item__content {
          width: calc(100% - 230px);
          .el-input__inner {
            width: 100%;
          }
        }
      }
      .long {
        /deep/ .el-form-item__content {
          width: 100%;
        }
      }
    }
    .line {
      margin: 0 4px;
      color: #ccc;
      text-align: center;
    }
    .address-style {
      margin-bottom: 20px !important;
      /deep/ .el-form-item__content {
        width: 80% !important;
      }
    }

    /** 单选框样式改为方块【复选框一样】start */
    /deep/ .el-radio__inner {
      border-radius: 2px !important;
    }

    /deep/ .el-radio__input.is-checked .el-radio__inner::after {
      content: "";
      width: 8px;
      height: 3px;
      border: 1px solid white;
      border-top: transparent;
      border-right: transparent;
      text-align: center;
      display: block;
      position: absolute;
      top: 3px;
      left: 2px;
      transform: rotate(-45deg);
      border-radius: 0px;
      background: none;
    }
    /** 单选框样式改为方块【复选框一样】end */
  }

  ::v-deep .el-form-item__content {
    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
  .dialogForm {
    ::v-deep .el-dialog {
      width: 917px;
      margin-top: 6vh !important;
      .el-dialog__body {
        height: 870px !important;
        overflow-y: auto;
        padding: 0 !important;
      }
    }
    .dialog-footer {
      text-align: right;
      margin: 0 20px 30px 20px;
    }
    .require {
      ::v-deep .el-form-item__label:before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }
    .work {
      /deep/ .el-input__icon,
      .el-icon-time {
        color: #0094ff;
      }
    }
    .iconfont,
    .icon-weizhi1 {
      color: #0094ff;
    }
    ::v-deep .el-date-editor {
      .el-input__suffix {
        position: absolute;
        height: 40px;
        left: 270px;
        top: 0px;
        .el-input__icon.el-icon-circle-close {
          display: none;
          // transition: none;
          // width: 26px;
          // position: relative;
          // font-size: 16px;
          // &:before {
          //   background-color: #fff; //这一条必须写，覆盖原先的日期icon
          // }
        }
      }
    }
    .dialogForm-form {
      margin: 20px 20px 0 20px;
    }
  }
}
.upload-img {
  /deep/ .el-dialog__body {
    padding: 30px 20px 20px 20px !important;
  }
}
.inner-map {
  #innerMap {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
  .myPageTop {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 40px;
    left: 20px;
    z-index: 111;
    /deep/ .el-input-group__append {
      background-color: #0094ff;
      .el-icon-search {
        color: #fff;
      }
    }
    /deep/ .amap-ui-poi-picker-search-results-container {
      width: 100%;
    }
    .searchResult {
      width: 300px;
      height: auto;
      color: #000;
      background: #fff;
      li {
        margin: 0;
        border-bottom: 1px solid #eee;
        font-size: 1em;
        padding: 7px;
        vertical-align: middle;
        cursor: pointer;
      }
      li:hover {
        color: #fff;
        background: #0094ff;
      }
    }
  }
  ::v-deep .el-dialog {
    width: 1200px;
    height: 60vh;
  }
  /deep/ .el-dialog__body {
    padding: 30px 0 0 0;
    height: calc(100% - 30px);
  }
  .saveLocation {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 2;
  }

  .infoWindow {
    width: 180px;
    font-size: 14px;
    color: #333;
    padding: 10px;
    border-radius: 4px;
    background: rgba($color: #fff, $alpha: 0.8);
    // 三角形
    .delta {
      position: absolute;
      left: calc(50% - 8px);
      bottom: 0;
      width: 0;
      height: 0;
      border-top: 10px solid #fff;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
    }
  }
}
.avatar-uploader {
  /deep/ .el-upload-list--picture-card {
    // height: 120px;
    .el-upload-list__item {
      margin: 0 20px 0 0;
      width: 148px;
      height: 120px;
    }
  }
  /deep/ .el-upload {
    width: 148px;
    height: 120px;
    border-radius: 8px;
    background: #f2f2f2;
    border: none;
    .el-icon-plus {
      color: #184fc3;
      font-size: 32px;
      font-weight: 600;
    }
  }
}
</style>
